var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "#E59724"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.687 22.6818C20.5703 22.6702 20.4303 22.6702 20.302 22.6818C17.5253 22.5885 15.3203 20.3135 15.3203 17.5135C15.3203 14.6552 17.6303 12.3335 20.5003 12.3335C23.3586 12.3335 25.6803 14.6552 25.6803 17.5135C25.6686 20.3135 23.4636 22.5885 20.687 22.6818Z",
    stroke: "#E59724",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1458 14.6665C31.4091 14.6665 33.2291 16.4982 33.2291 18.7498C33.2291 20.9548 31.4791 22.7515 29.2975 22.8332C29.2041 22.8215 29.0991 22.8215 28.9941 22.8332",
    stroke: "#E59724",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 26.9865C12.0305 28.8765 12.0305 31.9565 14.8538 33.8348C18.0622 35.9815 23.3238 35.9815 26.5322 33.8348C29.3555 31.9448 29.3555 28.8648 26.5322 26.9865C23.3355 24.8515 18.0738 24.8515 14.8538 26.9865Z",
    stroke: "#E59724",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3965 33.3335C32.2365 33.1585 33.0298 32.8202 33.6832 32.3185C35.5032 30.9535 35.5032 28.7018 33.6832 27.3368C33.0415 26.8468 32.2598 26.5202 31.4315 26.3335",
    stroke: "#E59724",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.1458678c9a5b682b19b0c277bd4aa3d1.svg";
export { ForwardRef as ReactComponent };